import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {environment} from '@app/environments/environment';
import {CognitoService} from '@app/app/shared/services/cognito.service';
import {Observable} from 'rxjs/Observable';
import * as awsIot from 'aws-iot-device-sdk';
import * as AWS from 'aws-sdk';
import 'rxjs/add/observable/of';

@Injectable()
export class AWSService {
  source1 = new Subject<any>();
  updateObservable = this.source1.asObservable();

  messagesSource = new Subject<any>();
  messagesObservable = this.messagesSource.asObservable();

  shadowsSource = new Subject<any>();
  shadowsObservable = this.shadowsSource.asObservable();

  notificationsSource = new Subject<any>();
  notificationsObservable = this.notificationsSource.asObservable();

  mqttClient;
  mqttClient2;

  constructor(private cognitoService: CognitoService) {
    //
  }

  public connect(): Observable<awsIot.device> {
    if (!this.mqttClient) {
      const subject: Subject<awsIot.device> = new Subject();
      const mObservable = subject.asObservable();

      this.cognitoService.getIdentity().subscribe((identity) => {
        this.mqttClient = awsIot.device({
          region: AWS.config.region,
          host: environment.aws.host,
          clientId: identity.ClientId,
          protocol: 'wss',
          maximumReconnectTimeMs: 8000,
          debug: false,
          accessKeyId: identity.AccessKeyId,
          secretKey: identity.SecretKey,
          sessionToken: identity.SessionToken
        });

        subject.next(this.mqttClient);
        subject.complete();
      });

      return mObservable;
    } else {
      return Observable.of(this.mqttClient);
    }
  }

  private isSet(prop) {
    return (typeof prop !== 'undefined' && prop !== null);
  }

  public connect2(): Observable<awsIot.device> {
    if (!this.mqttClient2) {
      const subject: Subject<awsIot.device> = new Subject();
      const mObservable = subject.asObservable();

      this.cognitoService.getIdentity().subscribe((identity) => {
        this.mqttClient2 = awsIot.device({
          region: AWS.config.region,
          host: environment.aws.host,
          clientId: identity.ClientId,
          protocol: 'wss',
          maximumReconnectTimeMs: 8000,
          debug: false,
          accessKeyId: identity.AccessKeyId,
          secretKey: identity.SecretKey,
          sessionToken: identity.SessionToken
        });

        this.mqttClient2.on('message', (sTopic, message) => {
          const msg = JSON.parse(message.toString().trim());
          this.messagesSource.next({topic: sTopic, message: msg});

          // We got a shadow here
          if (this.isSet(msg.current)) {
            const regExp = new RegExp('^\\$aws\\/things\\/Thing_(.*)\\/shadow\\/update\\/documents$', 'iu');

            const res = regExp.exec(sTopic);

            if (res !== null) {
              const parkId = res[1];

              if (this.isSet(msg.current.state) && this.isSet(msg.current.state.reported)) {
                const state = msg.current.state.reported;

                this.shadowsSource.next({shadow: state, parkId: parkId});
              }
            }
          }

          // We got notifications here
          if (this.isSet(msg.notifications)) {
            const regExp = new RegExp('^vortex\\/controllers\\/(.*)\\/notifications$', 'iu');

            const res = regExp.exec(sTopic);

            if (res !== null) {
              const parkId = res[1];

              this.notificationsSource.next({notifications: msg.notifications, parkId: parkId});
            }
          }
        });

        subject.next(this.mqttClient2);
        subject.complete();
      });

      return mObservable;
    } else {
      return Observable.of(this.mqttClient2);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/aws.service.ts